// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const triggerAnalyticsForApp = (_eventNameSuffix: string, _eventData: unknown): void => {}; // 'MoveSingleBoardDialog' was the app name

/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */
export default triggerAnalyticsForApp;
